// The Rule34 filter strip (score tier and best-of window) adds two marked terms to the search. They are marked so that
// they only ever apply to Rule34: when several sources are on, Rule34 gets real `score:>N` / `days:N` terms and every
// other source has them removed (a tag-only booru would treat them as a tag and find nothing).

export const RULE34_SCORE_PREFIX = "r34score:"
export const RULE34_DAYS_PREFIX = "r34days:"

/** Score tiers, named as on rule34.dev. `min` is the exclusive lower bound sent as score:>min. */
export const RULE34_SCORE_TIERS: { min: number; label: string; name: string }[] = [
  { min: -1, label: "Recent", name: "Recent (score > -1)" },
  { min: 1, label: "Popular", name: "Popular (score > 1)" },
  { min: 10, label: "Great", name: "Great (score > 10)" },
  { min: 50, label: "Very Good", name: "Very Good (score > 50)" },
  { min: 100, label: "Amazing", name: "Amazing (score > 100)" },
  { min: 200, label: "Legendary", name: "Legendary (score > 200)" },
  { min: 400, label: "Transcendent", name: "Transcendent (score > 400)" },
  { min: 666, label: "Mythic", name: "Mythic (score > 666)" },
]

/** Best-of windows. `days` is what the search is sent (3 hours is 0.125 days). */
export const RULE34_WINDOWS: { days: number; label: string }[] = [
  { days: 0.125, label: "3H" },
  { days: 0.25, label: "6H" },
  { days: 0.5, label: "12H" },
  { days: 1, label: "24H" },
  { days: 3, label: "3D" },
  { days: 7, label: "7D" },
  { days: 30, label: "30D" },
  { days: 90, label: "3MO" },
  { days: 180, label: "6MO" },
  { days: 365, label: "1Y" },
]

/** The marked terms for the chosen tier and window (either may be null for "any"). */
export function rule34FilterTokens(scoreMin: number | null, days: number | null): string[] {
  const tokens: string[] = []
  if (scoreMin !== null) tokens.push(`${RULE34_SCORE_PREFIX}>${scoreMin}`)
  if (days !== null) tokens.push(`${RULE34_DAYS_PREFIX}${days}`)
  return tokens
}

const TOKEN = /(^|[\s,])r34(score|days):/gi

/** The query for one source: Rule34 gets real terms, every other source has the marked terms taken out. */
export function applyRule34FilterTokens(tags: string, sourceId: string): string {
  if (!/r34(score|days):/i.test(tags)) return tags
  if (sourceId === "rule34") return tags.replace(TOKEN, (_m, lead: string, kind: string) => `${lead}${kind.toLowerCase()}:`)
  return tags
    .split(/(\s+)/)
    .filter((part) => !/^r34(score|days):/i.test(part))
    .join("")
    .replace(/\s{2,}/g, " ")
    .trim()
}
